import { render } from "./IconAuthors.vue?vue&type=template&id=7f7d780a"
const script = {}
script.render = render

export default script